import {Component, effect, inject, input} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LucideAngularModule} from 'lucide-angular';
import {User} from '@domain/user/user';
import {MemberDTO} from '@domain/member/member.dto';
import {UserMembershipSelectorService} from '@domain/user/user-membership-selector/user-membership-selector.service';

@Component({
  selector: 'app-user-membership-selector',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    LucideAngularModule
  ],
  styleUrl: './user-membership-selector.component.scss',
  templateUrl: './user-membership-selector.component.html'
})
export class UserMembershipSelectorComponent {

  public readonly user = input.required<User>();

  private readonly userMembershipSelectorService = inject(UserMembershipSelectorService);
  public readonly memberships = this.userMembershipSelectorService.memberships;
  private readonly currentMembership = this.userMembershipSelectorService.currentMembership;


  public readonly form = new FormGroup<{
    currentMembership: FormControl<MemberDTO | null>;
  }>({currentMembership: new FormControl<MemberDTO | null>(null)});

  public constructor() {
    effect(() => {
      const membership = this.memberships();
      const currentMembership = this.currentMembership()
        ? membership?.find(m => m.id === this.currentMembership()?.id) ?? null
        : null;
      this.form.patchValue({
        currentMembership: currentMembership
      });
    });
  }

  public setCurrentMembership(): void {
    this.userMembershipSelectorService.setCurrentMembership(this.form.value.currentMembership ?? null);
  }
}
